module.exports = __webpack_public_path__ + "07_bob_gold.a49db48e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/07_bob_gold.png
// module id = 7gkM
// module chunks = 0